/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddPrivacyRequestTagRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {AddPrivacyRequestTagResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const addPrivacyRequestTag = (request: AddPrivacyRequestTagRequest, options?: CashRequestOptions) => post<AddPrivacyRequestTagRequest, AddPrivacyRequestTagResponse>("/2.0/cash/add-privacy-request-tag", request, {...options, rejectOnError: true })